import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const BakerySolutions = () => <ProductDetailPage {...getProductPageConfig('bakerySolutions')} />;

export default BakerySolutions;
